import { Routes, Route } from "react-router-dom";
import { SITE_ORIGIN } from "../../siteConfig";

import ShirdiNavbar from "../../branchPages/shirdiBranch/sNavbar";
import ShirdiFooter from "../../branchPages/shirdiBranch/sFooter";

import Shirdi from "../../branchPages/shirdiBranch/shirdiBranch";
import ShirdiBranch from "../../separatePages/shirdiBranch";
import AboutShirdi from "../../branchPages/shirdiBranch/sAbout";
import HairTransplantinIndiaShirdi from "../../branchPages/shirdiBranch/HTindia/htinIndia.jsx";
import HairTransplantCostShirdi from "../../branchPages/shirdiBranch/HTindia/HTcostinIndia.jsx";
import HairTransplantSurgeryShirdi from "../../branchPages/shirdiBranch/HTindia/HTsurgeryinIndia.jsx";
import AboutHairTransplantShirdi from "../../branchPages/shirdiBranch/treatments/aboutHT.jsx";
import MaleHairTransplantShirdi from "../../branchPages/shirdiBranch/treatments/maleHT.jsx";
import FemaleHairTransplantShirdi from "../../branchPages/shirdiBranch/treatments/femaleHT.jsx";
import BeardHairTransplantShirdi from "../../branchPages/shirdiBranch/treatments/beardHT.jsx";
import EyebrowHairTransplantShirdi from "../../branchPages/shirdiBranch/treatments/eyebrowHT.jsx";
import EyelashHairTransplantShirdi from "../../branchPages/shirdiBranch/treatments/eyelashHT.jsx";
import ShirdiTrainingPage from "../../branchPages/shirdiBranch/others/shirditraining.jsx";
import ShirdiClientTestimonials from "../../branchPages/shirdiBranch/others/shirditestimonials.jsx";
import ShirdiFaqPage from "../../branchPages/shirdiBranch/others/shirdifaq.jsx";
import ShirdiTeam from "../../branchPages/shirdiBranch/others/shirditeam.jsx";

function ShirdiLayout({ children }) {
  return (
    <>
      <ShirdiNavbar />
      {children}
      <ShirdiFooter />
    </>
  );
}

const u = (path) => `${SITE_ORIGIN}${path}`;

export default function SiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ShirdiLayout><Shirdi /></ShirdiLayout>} />
      <Route path="/shirdi.php" element={<ShirdiLayout><ShirdiBranch url={u("/shirdi.php")} /></ShirdiLayout>} />
      <Route path="/description.php" element={<ShirdiLayout><AboutShirdi /></ShirdiLayout>} />
      <Route path="/our-Surgeons.php" element={<ShirdiLayout><ShirdiTeam url={u("/our-Surgeons.php")} /></ShirdiLayout>} />
      <Route path="/hair-transplant-in-shirdi.php" element={<ShirdiLayout><HairTransplantinIndiaShirdi /></ShirdiLayout>} />
      <Route path="/hair-transplant-cost-in-shirdi.php" element={<ShirdiLayout><HairTransplantCostShirdi /></ShirdiLayout>} />
      <Route path="/hair-transplant-surgery-in-shirdi.php" element={<ShirdiLayout><HairTransplantSurgeryShirdi /></ShirdiLayout>} />
      <Route path="/about-hair-transplants.php" element={<ShirdiLayout><AboutHairTransplantShirdi url={u("/about-hair-transplants.php")} /></ShirdiLayout>} />
      <Route path="/male-hair-transplants.php" element={<ShirdiLayout><MaleHairTransplantShirdi url={u("/male-hair-transplants.php")} /></ShirdiLayout>} />
      <Route path="/female-hair-transplants.php" element={<ShirdiLayout><FemaleHairTransplantShirdi url={u("/female-hair-transplants.php")} /></ShirdiLayout>} />
      <Route path="/beard-hair-transplants.php" element={<ShirdiLayout><BeardHairTransplantShirdi url={u("/beard-hair-transplants.php")} /></ShirdiLayout>} />
      <Route path="/eyebrow-hair-transplants.php" element={<ShirdiLayout><EyebrowHairTransplantShirdi url={u("/eyebrow-hair-transplants.php")} /></ShirdiLayout>} />
      <Route path="/eyelash-hair-transplants.php" element={<ShirdiLayout><EyelashHairTransplantShirdi url={u("/eyelash-hair-transplants.php")} /></ShirdiLayout>} />
      <Route path="/trainings.php" element={<ShirdiLayout><ShirdiTrainingPage url={u("/trainings.php")} /></ShirdiLayout>} />
      <Route path="/client-testimonials.php" element={<ShirdiLayout><ShirdiClientTestimonials url={u("/client-testimonials.php")} /></ShirdiLayout>} />
      <Route path="/faq.php" element={<ShirdiLayout><ShirdiFaqPage url={u("/faq.php")} /></ShirdiLayout>} />
    </Routes>
  );
}
